
import React from "react";
import { RssItem } from "./RssItem";
import { RssItemType, RssLayoutProps } from "./types";

export const RssCarouselLayout: React.FC<RssLayoutProps> = ({ items, content }) => {
  return (
    <div className="flex overflow-x-auto space-x-4 p-4">
      {items.map((item: RssItemType, index: number) => (
        <div key={index} className="flex-none w-80">
          <RssItem item={item} content={content} />
        </div>
      ))}
    </div>
  );
};

